import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import enableFormsFunctionality from './forms-common';
/**
 * Enables the "media kit" page functionality.
 */
const enableMediaKitFunctionality = () => {
    if ($('#media-kit').length === 0) {
        return;
    }
    /**
     * The "features" carousel.
     */
    const featuresCarousel = $('#features');
    _toggleCarouselControls();
    featuresCarousel.on('slid.bs.carousel', _toggleCarouselControls);
    // Don't slide the carousel if under "md" screen size limit
    featuresCarousel.on('slide.bs.carousel', e => {
        if (!window.matchMedia('(min-width: 768px)').matches) {
            e.preventDefault();
        }
    });
    /**
     * The "interview" form.
     */
    const interviewForm = $('#interview-form');
    // Attempts to submit the form after receiving the captcha token.
    window.captchaCallback = (_token) => {
        interviewForm.trigger('submit');
    };
    // Sets up the form submission functionality
    window.onloadCaptcha = () => {
        interviewForm.validate();
        // Re-parse the form for validation
        interviewForm.removeData('validator');
        interviewForm.removeData('unobtrusiveValidation');
        $.validator.unobtrusive.parse(interviewForm);
        // Enable the submit button
        const btn = $('.btn', interviewForm);
        btn.prop('disabled', false);
        // Execute the captcha when the button is clicked (and the form is valid)
        btn.on('click', e => {
            e.preventDefault();
            if (interviewForm.valid()) {
                hcaptcha.execute();
            }
        });
    };
    enableFormsFunctionality();
    /**
     * Toggles the "features" carousel controls.
     */
    function _toggleCarouselControls() {
        const first = $('.carousel-item:first-child', featuresCarousel);
        const last = $('.carousel-item:last-child', featuresCarousel);
        const controls = $('.carousel-control');
        const previousControl = $('.carousel-control-prev');
        const nextControl = $('.carousel-control-next');
        if (first.hasClass('active') && last.hasClass('active')) {
            controls.css('visibility', 'hidden');
        }
        // on first slide
        else if (first.hasClass('active')) {
            nextControl.css('visibility', 'visible');
            previousControl.css('visibility', 'hidden');
        }
        // on last slide
        else if (last.hasClass('active')) {
            previousControl.css('visibility', 'visible');
            nextControl.css('visibility', 'hidden');
        }
        // on inner slide
        else {
            controls.css('visibility', 'visible');
        }
    }
};
export default enableMediaKitFunctionality;
